

import { sanitizeFilename } from "../sanitizeFilename";

export function activityGeneratorToPptDocument(
result)
{
  const slides = [
  {
    kind: "title",
    title: result.pageTitle,
    subtitle: `${result.curriculumLabel} · ${result.activityTypeLabel} · ${result.durationLabel}`
  },
  {
    kind: "section",
    title: "Best used when",
    body: result.bestUsedWhen
  },
  {
    kind: "bullets",
    title: "Student copy — Objective",
    bullets: [result.studentCopy.objective].filter(Boolean)
  },
  {
    kind: "bullets",
    title: "Student copy — Steps",
    bullets: result.studentCopy.steps
  },
  {
    kind: "bullets",
    title: "Student copy — What you will do / Expected outcome",
    bullets: [
    `What you will do: ${result.studentCopy.whatYouWillDo}`,
    `Expected outcome: ${result.studentCopy.expectedOutcome}`]

  },
  {
    kind: "bullets",
    title: "Teacher copy — Objective",
    bullets: [result.teacherCopy.objective].filter(Boolean)
  },
  {
    kind: "bullets",
    title: "Teacher copy — Facilitation steps",
    bullets: result.teacherCopy.steps
  },
  {
    kind: "bullets",
    title: "Teacher copy — What you will do / Expected outcome",
    bullets: [
    `What you will do: ${result.teacherCopy.whatYouWillDo}`,
    `Expected outcome: ${result.teacherCopy.expectedOutcome}`]

  }];


  return {
    filename: sanitizeFilename(`${result.topicLabel} activity-plan`, "activity-generator"),
    title: result.pageTitle,
    subject: result.curriculumLabel,
    author: "Tema Activity Generator",
    slides
  };
}